import agentChatTakenByAuditorAudio from './audio/agent-chat-taken-by-auditor.wav';
import agentChatTransferApproveAudio from './audio/agent-chat-transfer-approve.mp3';
import agentChatTransferCancelAudio from './audio/agent-chat-transfer-reject.mp3';
import agentChatTransferRequestAudio from './audio/agent-chat-transfer-request.mp3';
import newInMsgAudio from './audio/blop-mark_diangelo.wav';
import logoB2CBotApi from './images/b2capi-icon-v2.png';
import B2ChatBBlue1 from './images/b2chat-b-blue-1.png';
import B2ChatBBlue2 from './images/b2chat-b-blue-2.png';
import B2ChatBBlue3 from './images/b2chat-b-blue-3.png';
import B2ChatBBlue4 from './images/b2chat-b-blue-4.png';
import B2ChatBLogo from './images/b2chat-b-blue.png';
import B2ChatBLigthBlueLogo from './images/b2chat-light-blue.png';
import B2ChatLight from './images/b2chat-light.png';
import B2ChatLogoDesktop from './images/b2chat-logo.desktop.png';
import B2ChatRobot from './images/b2chat-robot.png';
import blankAgentAvatar from './images/blank-agent-avatar.png';
import facebookMessengerLogo from './images/channels-setup/fb-messenger-36x36.svg';
import facebookMessengerLogoPlus from './images/channels-setup/fb-messenger-plus.svg';
import instagramLogo from './images/channels-setup/instagram-36x36.svg';
import instagramLogoPlus from './images/channels-setup/instagram-plus.svg';
import livechatLogo from './images/channels-setup/livechat-36x36.svg';
import livechatLogoPlus from './images/channels-setup/livechat-plus.svg';
import telegramLogo from './images/channels-setup/telegram-36x36.svg';
import telegramBotFather from './images/channels-setup/telegram-bot-father.jpeg';
import telegramLogoPlus from './images/channels-setup/telegram-plus.svg';
import telegramStep12 from './images/channels-setup/telegram-step-1-2-s.png';
import telegramStep13 from './images/channels-setup/telegram-step-1-4-s.png';
import telegramStep21 from './images/channels-setup/telegram-step-2-1-s.png';
import whatsappLogo from './images/channels-setup/whatsapp-36x36.svg';
import whatsappLogoPlus from './images/channels-setup/whatsapp-plus.svg';
import facebookMessengerSmallLogo20 from './images/fb-messenger-20x20.png';
import facebookMessengerSmallLogo from './images/fb-messenger-26x26.png';
import freshdeskLogo from './images/freshdesk-logo.png';
import instagramSmallLogo20 from './images/instagram-20x20.png';
import instagramSmallLogo from './images/instagram-26x26.png';
import livechatSmallLogo from './images/livechat-26x26.png';
import loadingGif from './images/loading.gif';
import NoImgAvailable from './images/noimageavailable.png';
import smsLogo from './images/sms-icon.png';
import telegramSmallLogo20 from './images/telegram-20x20.png';
import telegramSmallLogo from './images/telegram-26x26.png';
import terminal from './images/terminal.png';
import whatsappSmallLogo20 from './images/whatsapp-20x20.png';
import whatsappSmallLogo from './images/whatsapp-26x26.png';
import whatsappBusinessSmallLogo from './images/whatsapp-business-26x26.png';
import zendeskLogo from './images/zendesk-logo.png';

const agentChatTransferRejectAudio = agentChatTransferApproveAudio;

export {
  agentChatTakenByAuditorAudio,
  agentChatTransferApproveAudio,
  agentChatTransferCancelAudio,
  agentChatTransferRejectAudio,
  agentChatTransferRequestAudio,
  B2ChatBBlue1,
  B2ChatBBlue2,
  B2ChatBBlue3,
  B2ChatBBlue4,
  B2ChatBLigthBlueLogo,
  B2ChatBLogo,
  B2ChatLight,
  B2ChatLogoDesktop,
  B2ChatRobot,
  blankAgentAvatar,
  facebookMessengerLogo,
  facebookMessengerLogoPlus,
  facebookMessengerSmallLogo,
  facebookMessengerSmallLogo20,
  freshdeskLogo,
  instagramLogo,
  instagramLogoPlus,
  instagramSmallLogo,
  instagramSmallLogo20,
  livechatLogo,
  livechatLogoPlus,
  livechatSmallLogo,
  loadingGif,
  logoB2CBotApi,
  newInMsgAudio,
  NoImgAvailable,
  smsLogo,
  telegramBotFather,
  telegramLogo,
  telegramLogoPlus,
  telegramSmallLogo,
  telegramSmallLogo20,
  telegramStep12,
  telegramStep13,
  telegramStep21,
  terminal,
  whatsappBusinessSmallLogo,
  whatsappLogo,
  whatsappLogoPlus,
  whatsappSmallLogo,
  whatsappSmallLogo20,
  zendeskLogo,
};
